<template>
    <div v-if="bizAuth.viewRole.hasRight" class="page-setting biz-employee-role parent-frame" :class="{'fixed': listIsFixed}"  v-bind:style="{'min-height': myHeight}">
        <div class="tool-bar-mask"></div>
        <div class="page-header">
            <h1>
                {{$route.meta.title}}
                <word-tips-hover data="各工作崗位。範例：管理部、業務部、會計部" width="330px"></word-tips-hover>
            </h1>
            <div class="btn-group">
                <table-search @changeWord="setFilterWord" ></table-search>
                <div v-if="bizAuth.createRole.hasRight" class="default-button publish" @click="newRole">
                    新增職務部門
                </div>
                <!-- <div class="filter" @click="openFilter()">
                    <img src="@/assets/img/icon/filter_black.svg" alt="">
                </div> -->
                <!-- <dot-large-drop-menu bg="#ff9275" bgHover="#eb7859">
                    <ul>
                        <router-link :to="{ name: 'bizAddEmployeeRole'}">
                        <li>新增職務部門</li>
                        </router-link>
                    </ul>
                </dot-large-drop-menu > -->
            </div>
        </div>
        <employee-role-list></employee-role-list>
        <!-- <employee-role-filter :isOpen="isFilter" @filterClose="closeFilter" @changeFilter="setFilterQuery"></employee-role-filter> -->
    </div>
</template>
<script>
import Breadcrumb from '@/components/widge/Breadcrumb.vue';
import TableSearch from '@/components/widge/TableSearch.vue';
import DotLargeDropMenu from '@/components/widge/DotLargeDropMenu.vue';
import EmployeeRoleList from '@/components/bussiness/internalAuth/employeeRole/employeeRoleList.vue';
import EmployeeRoleFilter from '@/components/bussiness/internalAuth/employeeRole/employeeRoleFilter.vue';
import wordTipsHover from '@/components/bussiness/widges/tips/wordTipsHover.vue';

import { mapGetters } from 'vuex'

export default {
    data () {
        return {
            listIsFixed: false,
            myHeight: (window.innerHeight - 84) + 'px',
            isFilter: false,
        }
    },
    created (){
        
    },
    mounted () {
        this.$analyticsBiz.logEvent(this.$route.meta.title, { screen_name: this.$route.meta.title})
        window.addEventListener('scroll', this.handleScroll);
    },
    destroyed() {
        window.removeEventListener('scroll', this.handleScroll);
        document.getElementsByClassName('biz-tool-bar-wrap')[0].style.display = 'flex'
    },
    watch: {
        $route:{
            handler: function (val) {
                this.forceUpdate()
            },
            // immediate: true,
            deep: true
        },
        'bizAuth.viewRole.hasRight': function (val) {
            if(!val){
                this.$store.dispatch('setModalStatus', {state: true, type: 'bizNoRight'})
            }
        }
    },
    methods: {
        handleScroll: function () {
            if(!this.isModalMode){
                let scrollTop = event.target.documentElement.scrollTop
                if( scrollTop >= 50){
                    document.getElementsByClassName('biz-tool-bar-wrap')[0].style.display = 'none'
                    document.getElementsByClassName('parent-frame')[0].style.zIndex = '7'
                }else{
                    document.getElementsByClassName('biz-tool-bar-wrap')[0].style.display = 'flex'
                    document.getElementsByClassName('parent-frame')[0].style.zIndex = '7'
                    this.listIsFixed = false
                }

                if( scrollTop >= 115){
                    this.listIsFixed = true
                }
            }
        },
        openFilter: function () {
            this.isFilter = true
            this.$store.commit('modalStatus/set_filter_mode', true)
            document.getElementsByClassName('parent-frame')[0].style.zIndex = '8'
        },
        closeFilter: function (value) {
            this.isFilter = value
            this.$store.commit('modalStatus/set_filter_mode', false)
        },
        setFilterWord: function (value) {
            // TODO
            this.$store.dispatch('setlBizEmployeeRoleFilterWord', value)
            console.log(value)
        },
        setFilterQuery: function (value) {
            // TODO
            console.log(value)
        },
        newRole: function (){
            if(this.verifiedStatus === 'NORMAL'){
                this.$router.push({name: 'bizAddEmployeeRole'})
            }else{
                this.$store.dispatch('bizSetVerifiedAlarmBling', 200)
            }
        }
    },
    computed: {
        ...mapGetters({
            bizAuth: 'GET_BIZ_AUTH',
            verifiedStatus: 'GET_BIZ_COMPANY_IS_VERIFIED'
        })
    },
    components: {
        Breadcrumb,
        TableSearch,
        DotLargeDropMenu,
        EmployeeRoleList,
        EmployeeRoleFilter,
        wordTipsHover
    }
}
</script>
<style lang="scss">
    .biz-employee-role { 
        position: relative;
        margin-bottom: 100px;
    }
</style>


// WEBPACK FOOTER //
// src/pages/bussiness/internalAuth/employeeRole/employeeRoleDefault.vue